import { render, staticRenderFns } from "./handhome6.vue?vue&type=template&id=7b24fe24&scoped=true"
import script from "./handhome6.vue?vue&type=script&lang=js"
export * from "./handhome6.vue?vue&type=script&lang=js"
import style0 from "./handhome6.vue?vue&type=style&index=0&id=7b24fe24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24fe24",
  null
  
)

export default component.exports